<script>
    // @ts-nocheck

    import { createEventDispatcher } from 'svelte';

    import ButtonDropdown from "../../../dropdowns/ButtonDropdown/v1/ButtonDropdown.svelte";
    import Link from "../../../Navigation/Link/v1/Link.svelte";
    import IconButton from "../../../inputs/IconButton/v1/IconButton.svelte";

    /** @type {'h1' | 'h2'} */
    export let headingLevel = 'h1';

    /** @type {string} */
    export let title;

    /** @type {string} */
    export let backLinkText = undefined;

    /** @type {string} */
    export let backLinkUrl = undefined;

    /** @type {string} */
    export let backLinkTarget = '_self';

    /** @type {string} */
    export let backButtonText = undefined;

    /** @type {object[]} */
    export let menuItems = undefined;

    /** @type {boolean} */
    export let responsiveDropdown = true;

    /** @type {object} */
    export let i18n = {
        showMoreOptions: 'Show more options'
    }

    /** @type {boolean} */
    export let fixedHeaderSize = false;

    /** @type {string} */
    export let buttonDropdownId = "rnd" + Math.random().toString(36).replace('.', '');

    /** @type {'block'|'url'} */
    export let graphicType = 'url';

    /** @type {string} */
    export let iconSrc = '';

    /** @type {'course-hat'|'project-label'|'plan-label'|'topic-label'} */
    export let blockName = '';

    /** @type {string} */
    export let courseColour = undefined;

    /** @type {'success'|'error'|'caution'|'informative'|'draft'} */
    export let statusTag = undefined;

    /** @type {string} */
    export let statusTagText = '';

    const dispatch = createEventDispatcher();

    $: {
        if (backLinkUrl && !backLinkText) {
            console.error('Back link text is mandatory if there is a back link url.');
        }

        if (backLinkUrl && backButtonText) {
            console.error('Use either backLinkUrl or backButtonText.');
        }

        if (statusTag && !statusTagText) {
            console.warn('Text for status tag is mandatory if status tag type is set.');
        } else if (!statusTag && statusTagText) {
            console.warn('Status tag type is mandatory if status tag text is set.');
        }
    }

    $: textSizeCss = fixedHeaderSize ? 'font-size-xl' : 'font-size-l';
</script>

<header class="prom-page-header">
    {#if backLinkUrl}
        <div class="prom-page-header__back-link">
            <Link standalone href={backLinkUrl} text={backLinkText} target={backLinkTarget}
                iconClass="prom-page-header__back-link-icon" iconPlacement="start" />
        </div>
    {:else if backButtonText}
        <div class="prom-page-header__back-button-container">
            <IconButton
                htmlType="button"
                type="plain"
                large
                text={backButtonText}
                iconClass="prom-page-header__back-button-icon"
                on:click={() => dispatch('pageHeaderBack')}
            />
        </div>
    {/if}

    <div class="prom-page-header__header">
        <div class="prom-page-header__header-title">
            {#if graphicType === 'url' && iconSrc}
                <img class="prom-page-icon" width="32" height="32" src={iconSrc} alt="" />
            {:else if graphicType === 'block' && blockName}
                <span class={`prom-page-icon ${blockName} ${courseColour}`}></span>
            {/if}
            <div class="prom-page-header__header-title-wrapper">
                {#if headingLevel === 'h1'}
                    <h1 class="prom-page-header__header-title-text">{title}</h1>
                {/if}
                {#if headingLevel === 'h2'}
                    <h2 class="prom-page-header__header-title-text | {textSizeCss}">{title}</h2>
                {/if}
                {#if statusTag}
                    <span class="status-tag status-tag--{statusTag}">{statusTagText}</span>
                {/if}
            </div>
        </div>

        <div class="prom-page-header__header-menu">
            {#if menuItems}
                <ButtonDropdown
                    id={buttonDropdownId}
                    large
                    iconOnly
                    arrow={false}
                    iconClass="prom-page-header__header-menu-options"
                    items={menuItems}
                    ariaLabel={i18n.showMoreOptions}
                    type="secondary"
                    textOnly={false}
                    position="down"
                    responsive={responsiveDropdown}
                    on:selectedOption
                />
            {:else}
                <slot name="header-menu" />
            {/if}
        </div>
    </div>

    {#if $$slots.subHeader}
        <div class="prom-page-header__sub-header">
            <slot name="subHeader" />
        </div>
    {/if}
</header>
